<template>
  <v-dialog v-model="show">
    <v-card>
      <v-card-title>
        <h6 class="title font-weight-black">
          {{ $t('components.eventTabQuestionsAndStatistics.statistics') }}
        </h6>
      </v-card-title>

      <v-card-text>
        <blockquote class="blockquote" v-if="question === null">
          {{
            $t('components.eventTabQuestionsAndStatistics.noQuestionSelected')
          }}
        </blockquote>
        <QuestionStatistics
          v-else
          :question="question"
          :total_active_voters="total_active_voters"
          :quorum_value="quorum_value"
          :quorum="quorum"
          :event="event"
          :show_results_while_active="show_results_while_active"
          @get-question="$emit('get-question', $event)"
        ></QuestionStatistics>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close" color="info">{{ $t('buttons.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import QuestionStatistics from '@/components/QuestionStatistics.vue'
import Question from '@/models/Question.js'

export default {
  components: {
    QuestionStatistics,
  },

  props: {
    question: Question,
    show_results_while_active: Boolean,
    total_active_voters: Number,
    quorum_value: String,
    quorum: Boolean,
    value: Boolean,
    event: Object,
  },

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  methods: {
    close() {
      this.show = false
    },
  },
}
</script>
